<template>
  <div id="text">
    时间：
    <mark
      style="
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0);
        z-index: 999;
      "
      v-show="showSeason"
      @click.stop="showSeason = false"
    ></mark>
    <el-input
      readonly
      placeholder="请选择半年度"
      v-model="showValue"
      class="halfyear_box"
      style="width: 140px; height: 28px !important; line-height: 28px"
      @focus="showSeason = true"
    >
      <i slot="prefix" class="el-input__icon el-icon-date" size="mini"></i>
    </el-input>
    <el-card
      class="box-card"
      style="
        width: 240px;
        padding: 0 3px 20px;
        margin-left: 50px;
        margin-top: 10px;
        z-index: 9999;
        position: fixed;
      "
      v-show="showSeason"
    >
      <div
        slot="header"
        class="clearfix"
        style="text-align: center; padding: 0"
      >
        <button
          type="button"
          aria-label="前一年"
          class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"
          @click="prev"
        ></button>
        <span role="button" class="el-date-picker__header-label"
          >{{ year }}年</span
        >
        <button
          type="button"
          aria-label="后一年"
          @click="next"
          class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"
        ></button>
      </div>
      <div class="text item" style="text-align: center">
        <el-button
          type="text"
          size="medium"
          :class="
            showDisabled(
              year > maxYear || (year === maxYear && currSeason < 1),
              'left'
            )
          "
          :disabled="year > maxYear || (year === maxYear && currSeason < 1)"
          @click="selectSeason(0)"
          >上半年</el-button
        >
        <el-button
          type="text"
          size="medium"
          :class="
            showDisabled(
              year > maxYear || (year === maxYear && currSeason < 3),
              'left'
            )
          "
          :disabled="year > maxYear || (year === maxYear && currSeason < 3)"
          @click="selectSeason(2)"
          >下半年</el-button
        >
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  props: {
    valueArr: {
      default: () => {
        return ["01,03", "04,06", "07,09", "10,12"];
      },
      type: Array,
    },
    getValue: {
      default: () => {},
      type: Function,
    },
    defaultValue: {
      default: "",
      type: String,
    },
  },
  computed: {
    showDisabled() {
      return function (status, type) {
        if (status) {
          if (type === "left") {
            return "text-show-left-dis";
          } else {
            return "text-show-right-dis";
          }
        } else {
          if (type === "left") {
            return "text-show-left";
          } else {
            return "text-show-right";
          }
        }
      };
    },
  },
  data() {
    return {
      showSeason: false,
      season: "",
      year: new Date().getFullYear(),
      showValue: "",
      maxYear: new Date().getFullYear(),
      currSeason: 2,
    };
  },
  created() {
    this.getNowQuarter();
    if (this.defaultValue) {
      let value = this.defaultValue;
      let arr = value.split(",");
      this.year = parseInt(arr[0].slice(0, 4));
      let str = arr[0].slice(5, 7) + "," + arr[1].slice(5, 7);
      let arrAll = this.valueArr;
      console.log("现在是", arrAll);
      console.log("现在是", str);
      console.log("现在是", arrAll.indexOf(str));
      if (str == "10,12" || str == "07,09") {
        this.showValue = `${this.year}年下半年`;
      } else {
        this.showValue = `${this.year}年上半年`;
      }
    }
  },
  watch: {
    defaultValue: function (value, oldValue) {
      let arr = value.split(",");
      this.year = parseInt(arr[0].slice(0, 4));
      let str = arr[0].slice(5, 7) + "," + arr[1].slice(5, 7);
      let arrAll = this.valueArr;

      this.showValue = `${this.year}年${arrAll.indexOf(str) + 1}季度`;
    },
  },
  methods: {
    getNowQuarter() {
      var today = new Date();
      var selectMonth = today.getMonth() + 1; //getMonth返回0-11
      //下面是几个if
      if (selectMonth >= 1 && selectMonth <= 3) this.currSeason = 1;
      else if (selectMonth >= 4 && selectMonth <= 6) {
        this.currSeason = 2;
      } else if (selectMonth >= 7 && selectMonth <= 9) {
        this.currSeason = 3;
      } else if (selectMonth >= 10 && selectMonth <= 12) {
        this.currSeason = 4;
      }
    },
    one() {
      this.showSeason = false;
    },
    prev() {
      this.year = this.year * 1 - 1;
    },
    next() {
      this.year = this.year * 1 + 1;
    },
    selectSeason(i) {
      let that = this;
      that.season = i + 1;
      let arr = that.valueArr[i].split(",");
      that.showSeason = false;
      if (that.season == 1) {
        this.showValue = `${this.year}年上半年`;
      } else {
        this.showValue = `${this.year}年下半年`;
      }
      const varlues = that.year + "-" + arr[0] + "," + that.year + "-" + arr[1];
      that.$emit("getQuarter", varlues);
    },
  },
};
</script>
<style>
.text-show-left {
  float: left;
  width: 40%;
  color: #666666;
}
.text-show-right {
  float: right;
  width: 40%;
  color: #666666;
}
.text-show-left-dis {
  float: left;
  width: 40%;
  color: #c0c4cc;
}
.text-show-right-dis {
  float: right;
  width: 40%;
  color: #c0c4cc;
}
#text .el-input__icon {
  line-height: 28px;
}
#text .el-input__inner {
  line-height: 28px !important;
  height: 28px !important;
  font-size: 12px;
}
@media (min-width: 1200px) {
  .halfyear_box {
    width: 200px !important;
  }
}
</style>